import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MainFooter } from "../components";

const RegisterLayout = (props) => (
  <div class="flower-bg">
    <Container fluid className="">
      <Row>
        <Col className="logotxt text-left pt-2 pb-2 logoheader ml-5 pl-5">
          <a href='/'><img src={`${process.env.PUBLIC_URL}/images/logo-blk.png`} alt="best pdf to scorm converter" className="img-fluid logo bg-mycolor" /></a>
        </Col>
      </Row>
      <Row className="h-100">
        <Col
          className="main-content p-0 h-100"
          lg={{ size: 12 }}
          md={{ size: 12 }}
          sm="12"
          tag="main"
        >
          {props.children}
        </Col>
      </Row>
    </Container>
    {!props.noFooter && <MainFooter />} 
  </div>
);

export default RegisterLayout;